/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface PickCourseModuleIdModuleModuleTypeNameNamePl { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    module: PickCourseModuleIdModuleModuleTypeNameNamePl.ModuleEnum;
    /**
     * 
     */
    moduleType?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    namePl?: string;
}
export namespace PickCourseModuleIdModuleModuleTypeNameNamePl {
    export type ModuleEnum = 'feedback' | 'weekly-schedule' | 'attachments' | 'goals' | 'assessments' | 'checklist' | 'portfolio' | 'reflections' | 'epa-items';
    export const ModuleEnum = {
        Feedback: 'feedback' as ModuleEnum,
        WeeklySchedule: 'weekly-schedule' as ModuleEnum,
        Attachments: 'attachments' as ModuleEnum,
        Goals: 'goals' as ModuleEnum,
        Assessments: 'assessments' as ModuleEnum,
        Checklist: 'checklist' as ModuleEnum,
        Portfolio: 'portfolio' as ModuleEnum,
        Reflections: 'reflections' as ModuleEnum,
        EpaItems: 'epa-items' as ModuleEnum
    };
}


